import type { ECMCertificateDto } from '@customink/project-service-react-components/src/services/accounts/types';

export function isValid(certificate: ECMCertificateDto) {
  return certificate.valid && new Date(certificate.expirationDate) > new Date();
}

export function isPending(certificate: ECMCertificateDto) {
  return (
    (certificate.status === 'PENDING' ||
      certificate.status === 'PENDING-FUTURE' ||
      certificate.status === 'PENDING-MULTI' ||
      certificate.status === 'PENDING-SINGLE') &&
    new Date(certificate.expirationDate) > new Date()
  );
}
export const usStatesAndTerritories: Record<string, string> = {
  AL: 'Alabama',
  AK: 'Alaska',
  AS: 'American Samoa',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District of Columbia',
  FL: 'Florida',
  GA: 'Georgia',
  GU: 'Guam',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  MP: 'Northern Mariana Islands',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UM: 'U.S. Minor Outlying Islands',
  UT: 'Utah',
  VT: 'Vermont',
  VI: 'U.S. Virgin Islands',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
} as const;

export const avalaraTakingTooLongMessage =
  "The Tax Exemption portal is taking longer to initiate. No action is needed on your part. We will continue the initiation process and send you an email with a link to the Tax Exemption Portal once it's available. Or you can check back later.";
